import { ModularTableProps } from '@tryhackme/thm-ui-components';

import { ApiResponse } from 'src/common/interfaces';
import { RoomType } from 'src/common/interfaces/room';

export interface Submission {
  _id: string;
  maker: {
    username: string;
    avatar: string;
  };
  tester: {
    username: string;
    avatar: string;
  };
  data: {
    checked: {
      requested?: string;
      validated?: string;
      commissioned?: string;
      scheduled?: string;
      comments: string[];
      status: string;
    };
    type: string;
    title: string;
    imageURL: string;
    code: string;
    userWriteup: string;
  };
}

export interface SubmissionRowType {
  id: Submission['_id'];
  makerUsername?: Submission['maker']['username'];
  makerAvatar?: Submission['maker']['avatar'];
  userWriteupUrl?: Submission['data']['userWriteup'];
  testerUsername?: Submission['tester']['username'];
  testerAvatar?: Submission['tester']['avatar'];
  roomTitle: Submission['data']['title'];
  roomAvatar: Submission['data']['imageURL'];
  roomType: Submission['data']['type'];
  status: Submission['data']['checked']['status'];
  requested?: string | null;
  scheduled: Submission['data']['checked']['scheduled'];
  commissioned: Submission['data']['checked']['commissioned'];
  roomCode: Submission['data']['code'];
}

export interface SubmissionsData {
  docs: Submission[];
  totalDocs: number;
}
export interface SubmissionsParams {
  page: number;
  limit: number;
  search: string;
  sort: string;
  status: string | null;
  tester?: string | null;
}
export interface TestersData {
  userId: string;
  username: string;
}
export interface UpdateSubmissionsParams {
  roomCode: string;
  action: string;
  comment: string;
  date: number;
}
export interface StatusTagProps {
  status?: string;
}
export interface TypeTagProps {
  type: RoomType;
  userWriteupUrl?: string | null;
}

export interface SubmissionsTableProps {
  submissions: ApiResponse<SubmissionsData> | undefined;
  isLoading: boolean;
  activeSortColumn: SubmissionsTableType['activeSortColumn'];
  setActiveSortColumn: (value: SubmissionsTableType['activeSortColumn']) => void;
  submissionsParams: SubmissionsParams;
  setSubmissionsParams: SetSubmissionsParamsFunction;
}

export enum SubmissionsSortFieldTypes {
  ROOM = 'data.code',
  MAKER = 'maker.username',
  TYPE = 'data.type',
  TESTER = 'tester.username',
  REQUESTED = 'data.checked.requested',
  STATUS = 'data.checked.status',
  SCHEDULED = 'data.checked.scheduled',
}

export type SetSubmissionsParamsFunction = React.Dispatch<React.SetStateAction<SubmissionsParams>>;
export type SetSubmissionsActiveSortColumnFunction = React.Dispatch<
  React.SetStateAction<SubmissionsTableType['activeSortColumn']>
>;

export type SubmissionsTableType = ModularTableProps<SubmissionRowType>;
